import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AlertService } from 'src/app/shared/alert/shared/alert.service';
import { AlertTypes } from 'src/app/shared/alert/shared/alert-types';
import { SchemaDeviceInfo } from 'src/app/project/project-schema/shared/interfaces/schema-route-station-info.interface';
import { DeviceInfoRow, deviceInfoRowsToText, toDeviceInfoRows } from 'src/app/project/shared/functions/schema-device-info';

export interface DeviceInfoDialogData {
  /** Überschrift, z. B. Kanaltyp und DE-Nummer */
  title: string;
  device: SchemaDeviceInfo;
}

/**
 * Zeigt die Geräteinformationen (Gerätename, Seriennummer, Version) eines
 * Datenendkanals; die Seriennummer einzeln und alle Werte zusammen lassen sich
 * in die Zwischenablage kopieren.
 */
@Component({
  selector: 'avs-device-info-dialog',
  standalone: false,
  templateUrl: './device-info-dialog.component.html',
  styleUrl: './device-info-dialog.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeviceInfoDialogComponent {
  public readonly rows: DeviceInfoRow[];
  public readonly serialNumber: string | null;

  constructor(@Inject(MAT_DIALOG_DATA) public data: DeviceInfoDialogData,
    private dialogRef: MatDialogRef<DeviceInfoDialogComponent>,
    private alertService: AlertService) {
    this.rows = toDeviceInfoRows(data.device);
    this.serialNumber = data.device.serialNumber || null;
  }

  public onCopySerialNumberClicked(): Promise<void> {
    if (!this.serialNumber) { return Promise.resolve(); }
    return this.copyToClipboard(this.serialNumber, 'Seriennummer wurde in die Zwischenablage kopiert.');
  }

  public onCopyAllClicked(): Promise<void> {
    return this.copyToClipboard(deviceInfoRowsToText(this.rows), 'Geräteinformationen wurden in die Zwischenablage kopiert.');
  }

  public onCloseClicked(): void {
    this.dialogRef.close();
  }

  private async copyToClipboard(text: string, successMessage: string): Promise<void> {
    try {
      await navigator.clipboard.writeText(text);
      this.alertService.alert(successMessage, AlertTypes.success);
    } catch {
      this.alertService.alert('Kopieren in die Zwischenablage ist fehlgeschlagen.', AlertTypes.error);
    }
  }
}
